// extracted by mini-css-extract-plugin
export default {"wrapperTop":"DailyInfo_wrapperTop__jqIm+"};